import { useEffect, useState } from "react";
import { useNavSelector } from "../camera/nav.js";
import { perfSnapshot } from "./stats.js";

/** The dev overlay: FPS and draw calls, toggled with the backquote key. */
export function PerfOverlay() {
  const on = useNavSelector((s) => s.perf);
  const [, tick] = useState(0);
  useEffect(() => {
    if (!on) return;
    const id = setInterval(() => tick((n) => n + 1), 500);
    return () => clearInterval(id);
  }, [on]);
  if (!on) return null;
  const p = perfSnapshot;
  const rate = p.frameloop === "demand" && p.frames === 0 ? "idle" : `${p.fps} fps`;
  return (
    <pre className="world-perf" data-testid="world-perf" aria-hidden="true">
      {`${rate}  ${p.frameloop}\ncalls ${p.calls}  tris ${p.triangles}\ngeo ${p.geometries}  tex ${p.textures}`}
    </pre>
  );
}
